import styled from 'styled-components';

export const CartHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
`;

export const CartHeaderTitle = styled.div`
  flex: 1;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: var(--v3-text-color);
`;

export const CartHeaderClear = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  padding: 4px;
  color: var(--v3-text-color-secondary);
  cursor: pointer;

  &:hover {
    color: var(--v3-text-color);
  }
`;
